module.exports = __webpack_public_path__ + "static/r1-3848389c7d38dd31487b1314a01ba2bc.png";